import React, {useState, useEffect} from 'react';
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, CssBaseline, Box, Toolbar, Grid, Stack, Button, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link, useParams } from "react-router-dom";
import * as CONSTANTS from "../constants"
import NoPermission from './NoPermission';
import ApproveTopicTable from '../components/approve_topic/ApproveTopicTable';

import { fetch_statistic } from '../services/topic_approve';

const DoubleBorderBox = ({title, number}) => {
  return (
    <Box
      sx={{
        border: '6px double black', // Double-line border
        borderRadius: 5,
        width: "10rem",
        height: "10rem",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
        boxSizing: 'border-box',
      }}
    >
      <Typography variant="h6" sx={{ fontSize: '1.5rem', textAlign: "center"  }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '2rem', fontWeight: 'bold' }}>
        {number}
      </Typography>
    </Box>
  );
};

const NoBorderBox = ({symbol}) => {
    return (
      <Box
        sx={{
          width: "auto",
          height: "10rem",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}
      >
        <Typography variant="h6" sx={{ fontSize: '5rem', fontWeight: 'bold' }}>
          {symbol}
        </Typography>
      </Box>
    );
};

const TitleBox = ({title}) => {
    return (
      <Box
        sx={{
          width: "20rem",
          height: "10rem",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}
      >
        <Typography variant="h6" sx={{ fontSize: '3rem', textAlign: "center" }}>
          {title}
        </Typography>
      </Box>
    );
};



const ApproveTopic = () => {

    let {lang} = useParams();

    document.title = `${CONSTANTS.DRAWER.APPROVE_TOPIC[lang]} - Wotagei Zone`

    const [stat, setStat] = useState(null);
    const [hasPermission, setHasPermission] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [drawerOpen, setDrawerOpen] = useState(false);
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    // fetch data
    const fetchStat = async () => {
        const [status, result] = await fetch_statistic();
        if (status === 200) {
            setStat(result);
            setHasPermission(true);
        }
        setIsLoading(false);
    }

    useEffect(()=>{
        fetchStat();
    }, [])

    return (
        isLoading?
        <></>
        :
        (
            hasPermission?
            <Box >
                <CssBaseline />
                <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
                <Box sx={{ display: 'flex' }}>
                    <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                    <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                        <Toolbar />
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography 
                                    xs={12}
                                    variant="h5" 
                                    style={{
                                        textAlign: "left",
                                        fontWeight: "bolder",
                                    }}
                                >
                                    {CONSTANTS.DRAWER.APPROVE_TOPIC[lang].toUpperCase()}
                                </Typography>

                                <Box pt={3} pb={3} xs={12} md={12} height={'100%'} sx={{width: '100%'}}>
                                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                                        <Link style={{ flex: 1, textDecoration: 'none', height: '100%' }} >
                                            <Button variant="outlined" fullWidth disabled>
                                                {CONSTANTS.APPROVE_TOPIC.DASHBOARD[lang]}
                                            </Button>
                                        </Link>
                                        <Link style={{ flex: 1, textDecoration: 'none', height: '100%' }} to={`/${lang}/approve-topic/wazaren/`}>
                                            <Button variant="outlined" fullWidth>
                                                {CONSTANTS.DRAWER.WAZAREN[lang]}
                                            </Button>
                                        </Link>
                                        <Link style={{ flex: 1, textDecoration: 'none', height: '100%' }}  to={`/${lang}/approve-topic/wotageishi/`}>
                                            <Button variant="outlined" fullWidth>
                                                {CONSTANTS.DRAWER.WOTAGEISHI[lang]}
                                            </Button>
                                        </Link>
                                        <Link style={{ flex: 1, textDecoration: 'none', height: '100%' }} to={`/${lang}/approve-topic/organization/`}>
                                            <Button variant="outlined" fullWidth >
                                                {CONSTANTS.DRAWER.ORGANIZATION[lang]}
                                            </Button>
                                        </Link>
                                    </Stack>

                                </Box>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box xs={12} md={12} height={'100%'} sx={{width: '100%'}}>
                                    <ApproveTopicTable lang={lang} stat={stat} />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            :
            <NoPermission />
        )
    );
};
 
export default ApproveTopic;